(() => {
  const bar = document.querySelector('[data-zc-buy-bar]');
  const main = document.getElementById('MainContent');
  if (!bar || !main || bar.dataset.initialized) return;
  bar.dataset.initialized = 'true';
  const pid = bar.dataset.productId;
  const variants = JSON.parse(bar.querySelector('[data-zc-variants]').textContent);
  const select = bar.querySelector('[data-zc-kit]');
  const single = bar.querySelector('[data-zc-single]');
  const total = bar.querySelector('[data-zc-total]');
  const perUnit = bar.querySelector('[data-zc-unit]');
  const compare = bar.querySelector('[data-zc-compare]');
  const compareValue = bar.querySelector('[data-zc-compare-value]');
  const saleLabel = bar.querySelector('[data-zc-sale-label]');
  const shipping = bar.querySelector('[data-zc-shipping]');
  const popular = bar.querySelector('[data-zc-popular]');
  const revealRequests = new WeakSet();
  const action = bar.querySelector('[data-zc-action]');
  const photo = bar.querySelector('.zc-buy-bar__image img');
  const defaultPhoto = photo?.getAttribute('src');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const currency = new Intl.NumberFormat('pt-BR', {style:'currency',currency:'BRL'});
  let internalSelection = false;
  let initializedDefault = false, fallbackApplied = false, userChoice = false, busy = false, frame = 0, timer;
  let staticKey = '3', optionSignature = '', exposed = false;
  const quantity = text => {
    const value = (text || '').trim();
    const match = value.match(/leve\s*(\d+)/i) || value.match(/(\d+)\s*(?:unidades?|frascos?)/i);
    return match ? Number(match[1]) : null;
  };
  const amount = text => {
    const match = (text || '').replace(/\u00a0/g,' ').match(/R\$\s*([\d.]+,\d{2})/);
    return match ? Math.round(Number(match[1].replace(/\./g,'').replace(',','.')) * 100) : null;
  };
  const label = n => n === 1 ? bar.dataset.one : bar.dataset.many.replace('[quantity]',String(n));
  const blocked = el => !el || el.disabled || el.getAttribute('aria-disabled') === 'true' || el.getAttribute('aria-busy') === 'true' || el.getAttribute('data-instant-disabled')?.trim() === 'true';
  const locked = el => Boolean(el?.closest('.kaching-bundles__scratch-off--unscratched,[inert],[aria-disabled="true"],.kaching-bundles__bar--sold-out'));
  const visible = el => {
    if (!el || el.hidden) return false;
    const r = el.getBoundingClientRect(), s = getComputedStyle(el);
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && s.display !== 'none' && s.visibility !== 'hidden' && Number(s.opacity) !== 0;
  };
  const emit = (event, choice) => {
    if (window.Shopify?.designMode) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event,cro_release:bar.dataset.release,cro_product:bar.dataset.handle,cro_kit_quantity:choice?.quantity || 0});
  };
  const cards = () => Array.from(main.querySelectorAll('#compra .product-card')).map(card => {
    const n = quantity(card.querySelector('.badge')?.textContent);
    const price = amount(card.querySelector('.product-price-current')?.textContent);
    const comparePrice = amount(card.querySelector('.product-price-old')?.textContent);
    const target = Array.from(card.querySelectorAll('a')).find(a => a.classList.contains('btn-primary') && /seguro\.zencial\.com\.br\/r\//.test(a.href));
    return n && price > 0 && target ? {key:String(n),quantity:n,price,comparePrice,target,image:card.querySelector('.product-media img')?.getAttribute('src'),card} : null;
  }).filter(Boolean);
  const nativeForm = () => Array.from(main.querySelectorAll('form[action*="/cart/add"],form[data-instant-form-product-id]')).find(form => {
    if (form.hasAttribute('data-instant-form-product-id')) return form.getAttribute('data-instant-form-product-id') === pid;
    const input = form.querySelector('[name="id"]');
    return variants.some(v => String(v.id) === String(input?.value)) && form.querySelector('button[type="submit"]');
  });
  const getState = () => {
    const form = nativeForm();
    const bundle = main.querySelector('kaching-bundle[product-id="' + pid + '"]');
    const target = form?.querySelector('button[type="submit"],[data-instant-action-type="redirect-to-cart"][data-instant-action-id="' + pid + '"],[data-instant-action-type="add-to-cart"][data-instant-action-id="' + pid + '"]');
    const rows = Array.from(bundle?.querySelectorAll('[data-deal-bar-id]') || []);
    if (rows.length && form && target) {
      const options = rows.map(row => {
        const n = quantity(row.querySelector('.kaching-bundles__bar-title')?.textContent);
        const price = amount(row.querySelector('.kaching-bundles__bar-price')?.textContent);
        const comparePrice = amount(row.querySelector('.kaching-bundles__bar-full-price')?.textContent);
        const radio = row.querySelector('input[type="radio"]');
        return n && price > 0 && radio ? {key:row.getAttribute('data-deal-bar-id'),quantity:n,price,comparePrice,row,radio,disabled:radio.disabled || locked(row)} : null;
      }).filter(Boolean);
      const choice = options.find(o => o.radio.checked && !o.disabled) || null;
      return {mode:'bundle',form,bundle,target,anchor:target,options,choice};
    }
    if (form && target) {
      const id = form.querySelector('[name="id"]')?.value || form.getAttribute('data-instant-form-variant-id');
      const variant = variants.find(v => String(v.id) === String(id));
      const qtyInput = form.querySelector('[name="quantity"]') || Array.from(main.querySelectorAll('input[name="quantity"]')).find(i => i.getAttribute('form') === form.getAttribute('id'));
      const count = Math.max(1,Number(qtyInput?.value) || 1);
      const pack = quantity(variant?.title) || 1;
      const choice = variant && variant.price > 0 ? {key:String(variant.id),quantity:count*pack,price:variant.price*count,comparePrice:variant.compare_at_price*count,variant} : null;
      const kitVariants = variants.length > 1 && variants.every(v => v.available && (quantity(v.title) || /^(default title|envy hair)$/i.test(v.title)));
      const options = kitVariants ? variants.map(v => ({key:String(v.id),quantity:quantity(v.title) || 1,price:v.price,comparePrice:v.compare_at_price,variant:v,disabled:!v.available})) : [];
      return {mode:'native',form,bundle,target,anchor:target,options,choice,qtyInput,unavailable:variant?.available === false};
    }
    const options = cards();
    if (options.length) {
      const choice = options.find(o => o.key === staticKey) || options[0];
      return {mode:'links',target:choice.target,anchor:main.querySelector('.hero .cta a[href="#compra"]') || choice.target,options,choice};
    }
    return null;
  };
  const choose = (state, option) => {
    if (!option || option.disabled) return;
    internalSelection = true;
    try {
    if (state.mode === 'bundle') {
      (option.row.querySelector('[role="button"]') || option.radio).click();
    } else if (state.mode === 'links') {
      staticKey = option.key;
    } else if (state.options.length) {
      const picker = main.querySelector('select[name="id"]');
      if (picker && picker.querySelector('option[value="' + option.key + '"]')) {
        picker.value = option.key;
        picker.dispatchEvent(new Event('change',{bubbles:true}));
      } else {
        const input = state.form.querySelector('[name="id"]');
        if (input) { input.value = option.key; input.dispatchEvent(new Event('change',{bubbles:true})); }
      }
    }
    } finally { internalSelection = false; }
  };
  const setText = (node,text) => { if (node.textContent !== text) node.textContent = text; };
  const updateOptions = state => {
    const available = state.options.filter(o => !o.disabled);
    const items = available.map(o => ({value:o.key,text:label(o.quantity)}));
    if (!state.choice) items.unshift({value:'',text:bar.dataset.choose});
    const signature = JSON.stringify(items);
    if (signature !== optionSignature) {
      optionSignature = signature;
      select.replaceChildren(...items.map(item => { const o = document.createElement('option'); o.value=item.value; o.textContent=item.text; return o; }));
    }
    if (state.choice) select.value = state.choice.key;
    select.parentElement.hidden = available.length < 2;
    single.hidden = available.length >= 2;
    setText(single,state.choice ? label(state.choice.quantity) : bar.dataset.choose);
  };
  const render = () => {
    frame = 0;
    let state = getState();
    if (!state) { bar.hidden=true; return; }
    if (bar.dataset.autoReveal === 'true' && state.mode === 'bundle') {
      const covered = state.options.find(o => o.quantity === 3)?.row.closest('.kaching-bundles__scratch-off--unscratched');
      const reveal = covered?.querySelector('.kaching-bundles__scratch-off-canvas[role="button"]');
      if (reveal && !revealRequests.has(reveal)) {
        revealRequests.add(reveal);
        internalSelection=true;
        try { reveal.dispatchEvent(new KeyboardEvent('keydown',{key:'Enter',code:'Enter',bubbles:true,cancelable:true})); } finally { internalSelection=false; }
        state=getState();
      }
    }
    if (!initializedDefault && !userChoice && !new URLSearchParams(location.search).has('variant')) {
      const preferred = state.options.find(o => o.quantity === 3 && !o.disabled);
      if (preferred) {
        initializedDefault = true;
        if (state.choice?.key !== preferred.key) choose(state,preferred);
        state = getState();
      } else if (!state.choice && !fallbackApplied) {
        const first = state.options.find(o => o.quantity === 1 && !o.disabled);
        if (first) { fallbackApplied=true; choose(state,first); state=getState(); }
      }
    }
    updateOptions(state);
    const choice = state.choice;
    const disabled = blocked(state.target) || state.unavailable;
    setText(total,choice ? currency.format(choice.price/100) : bar.dataset.choose);
    setText(perUnit,choice ? currency.format(choice.price/choice.quantity/100) : '');
    const discounted = Boolean(choice && Number.isFinite(choice.comparePrice) && choice.comparePrice > choice.price);
    if (compare) compare.hidden = !discounted;
    if (saleLabel) saleLabel.hidden = !discounted;
    if (compareValue) setText(compareValue,discounted ? currency.format(choice.comparePrice/100) : '');
    if (popular) popular.hidden = !choice || choice.quantity !== 3;
    shipping.hidden = !choice || choice.price < Number(bar.dataset.freeShipping);
    let image = choice?.image || (choice?.variant?.featured_image?.src) || defaultPhoto;
    if (image) { const small = new URL(image,location.origin); small.searchParams.set('width','160'); image=small.href; }
    if (photo && image && photo.getAttribute('src') !== image) { photo.removeAttribute('srcset'); photo.src=image; }
    setText(action,busy ? bar.dataset.busy : disabled ? bar.dataset.soldOut : !choice ? bar.dataset.view : state.mode === 'links' ? bar.dataset.buy : bar.dataset.add);
    action.disabled = busy || disabled;
    const after = state.anchor.getBoundingClientRect().bottom <= 0;
    const offersVisible = visible(main.querySelector('#compra'));
    const dialogOpen = Array.from(document.querySelectorAll('cart-drawer,dialog,[role="dialog"][aria-modal="true"],.menu-drawer,.search-modal')).some(visible);
    const focused = document.activeElement;
    const typing = !bar.contains(focused) && focused?.matches('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]),textarea,select,[contenteditable="true"]');
    const show = after && !offersVisible && !dialogOpen && !typing;
    bar.hidden = !show;
    document.body.classList.add('zc-buy-bar-space');
    if (show && !exposed) { exposed = true; emit('zencial_cro_pdp_sticky_view',choice); }
  };
  const schedule = () => { if (!frame) frame=requestAnimationFrame(render); };
  const observer = new MutationObserver(schedule);
  observer.observe(main,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','checked','disabled','aria-disabled','aria-busy','value','data-instant-form-variant-id']});
  document.querySelectorAll('cart-drawer,dialog,[role="dialog"][aria-modal="true"],.menu-drawer,.search-modal').forEach(el => observer.observe(el,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style','open','aria-hidden']}));
  main.addEventListener('click',event => {
    if (!internalSelection && event.isTrusted && event.target.closest('[data-deal-bar-id],variant-selects,variant-radios,select[name="id"]') && !event.target.closest('.kaching-bundles__scratch-off--unscratched')) userChoice=true;
    schedule();
  },true);
  main.addEventListener('change',event => {
    if (!internalSelection && event.isTrusted && event.target.matches('input[type="radio"],select,input[name="quantity"]')) userChoice=true;
    schedule();
  });
  select.addEventListener('change',() => {
    userChoice=true;
    const state=getState();
    choose(state,state.options.find(o => o.key === select.value));
    schedule();
  });
  action.addEventListener('click',() => {
    const state=getState();
    if (!state || busy || blocked(state.target) || state.unavailable) return;
    if (!state.choice) {
      (state.bundle || state.form || state.anchor).scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'center'});
      return;
    }
    emit('zencial_cro_pdp_sticky_click',state.choice);
    busy=true;
    render();
    state.target.click();
    timer=setTimeout(() => {busy=false;schedule();},1800);
  });
  document.addEventListener('focusin',schedule);
  document.addEventListener('focusout',schedule);
  document.addEventListener('transitionend',schedule);
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('pageshow',() => {busy=false;clearTimeout(timer);schedule();});
  render();
})();


